// ============================================
// Chat Module - Index (ES6 Entry Point)
// ============================================

// Overlay functions
import {
  openChatOverlay,
  closeChatOverlay,
  showNoChatState,
  showChatContent,
  toggleSidebar,
  closeMobileMenus,
  showTab
} from './overlay.js';

// List management
import {
  loadChatList,
  invalidateChatCache,
  renderChatList,
  filterChats,
  toggleShowHidden,
  initChatListLongPress
} from './list.js';

// Actions (modal, delete, hide) - 세션 구조 전용
import {
  openRoomActionModal,
  closeRoomActionModal,
  toggleHideChat,
  confirmDeleteFromModal,
  deleteSession
} from './actions.js';

// Load session & info display
import {
  showWorldInfoModal,
  showWorldInfo,
  showCharacterProfile,
  showImageModal
} from './load.js';

// Messaging & Streaming
import {
  clearMessages,
  appendMessage,
  appendMessageWithoutScroll,
  createStreamingMessage,
  getStreamingState,
  setStreamingTargetText,
  isSilentlyComplete,
  preprocessAIContent,
  formatAIMessageStreaming,
  finalizeStreamingMessage,
  stopStreaming
} from './messaging.js';

// Parser & Formatting
import {
  MARKER_REGEX,
  parseMarkerType,
  parseNewMarkerSystem,
  parseAIContent,
  parseAIContentStreaming,
  getCurrentCharacterName,
  getCharacterNames,
  getCharacterAvatar,
  renderAvatarHTML,
  formatAIMessage
} from './parser.js';

// Message Actions (continue, regenerate, edit, choices)
import {
  continueStory,
  regenerateLastResponse,
  openEditMessageModal,
  closeEditMessageModal,
  saveEditedMessage,
  initChoiceToggle,
  displayChoices,
  toggleChoicePopup,
  clearChoices
} from './message-actions.js';

// Context Menu (long press)
import {
  initMessageLongPress,
  setupMessageLongPress,
  showMessageContextMenu,
  closeMessageContextMenu,
  copyMessageContent,
  showRollbackConfirm,
  executeRollback
} from './context-menu.js';

// User Note
import {
  renderUserNoteTab,
  saveUserNote,
  updateCharCount,
  closeModal
} from './user-note.js';

// Send Message
import {
  sendMessage,
  formatUserMessage,
  showLoading,
  removeLoading
} from './send.js';

// Model Selector
import {
  getModelDisplayName,
  updateModelNameDisplay,
  openModelSelector,
  closeModelSelector,
  selectModel
} from './model-selector.js';

// Event handlers (onclick 대체)
import { initChatEvents } from './events.js';

// ============================================
// 초기화
// ============================================

function init() {
  console.log('[ChatModule] ES6 모듈 초기화');

  // 메시지 Long Press 이벤트 위임 설정 (메모리 누수 방지)
  initMessageLongPress();

  // 채팅 목록 Long Press 이벤트 위임 설정 (메모리 누수 방지)
  initChatListLongPress();
}

// ============================================
// 모듈 초기화
// ============================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// ============================================
// Public API
// ============================================

const ChatModule = {
  // 오버레이
  openChatOverlay,
  closeChatOverlay,
  showNoChatState,
  showChatContent,
  // 모바일
  toggleSidebar,
  closeMobileMenus,
  showTab,
  // 목록 관리
  loadChatList,
  invalidateChatCache,
  renderChatList,
  filterChats,
  toggleShowHidden,
  // 액션 (세션 구조)
  openRoomActionModal,
  closeRoomActionModal,
  toggleHideChat,
  confirmDeleteFromModal,
  deleteSession,
  // 세션 로드 & 정보 표시
  showWorldInfoModal,
  showWorldInfo,
  showCharacterProfile,
  showImageModal,
  // 메시징 & 스트리밍
  clearMessages,
  appendMessage,
  appendMessageWithoutScroll,
  createStreamingMessage,
  getStreamingState,
  setStreamingTargetText,
  isSilentlyComplete,
  preprocessAIContent,
  formatAIMessageStreaming,
  finalizeStreamingMessage,
  stopStreaming,
  // 파싱 & 포맷팅
  MARKER_REGEX,
  parseMarkerType,
  parseNewMarkerSystem,
  parseAIContent,
  parseAIContentStreaming,
  getCurrentCharacterName,
  getCharacterNames,
  getCharacterAvatar,
  renderAvatarHTML,
  formatAIMessage,
  // 메시지 액션
  continueStory,
  regenerateLastResponse,
  openEditMessageModal,
  closeEditMessageModal,
  saveEditedMessage,
  initChoiceToggle,
  displayChoices,
  toggleChoicePopup,
  clearChoices,
  // 컨텍스트 메뉴
  setupMessageLongPress,
  showMessageContextMenu,
  closeMessageContextMenu,
  copyMessageContent,
  showRollbackConfirm,
  executeRollback,
  // 유저 노트
  renderUserNoteTab,
  saveUserNote,
  updateCharCount,
  closeModal,
  // 메시지 전송
  sendMessage,
  formatUserMessage,
  showLoading,
  removeLoading,
  // 모델 선택
  getModelDisplayName,
  updateModelNameDisplay,
  openModelSelector,
  closeModelSelector,
  selectModel
};

// 전역 노출 (기존 코드 호환성)
window.ChatModule = ChatModule;

// inline oninput 핸들러용 (user-note.js, profile/manager.js)
window.updateCharCount = updateCharCount;

export default ChatModule;
